<template>
  <div
    class="overlay"
    aria-modal="true"
    role="dialog"
    tabindex="-1"
    @click.self="handleSelfClick"
  >
    <transition
      v-if="dialogStore.componentName"
      v-bind="dialogStore.componentProps.transition"
    >
      <component
        :is="dialogComponent"
        v-bind="dialogStore.componentProps"
        @action="dialogStore.componentProps.action"
        @closed="onClosed"
      />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { useDialogStore } from '~/stores/dialog.ts';

const { toggleComponent } = useModals();
const { loaders } = useLoader();
const dialogStore = useDialogStore();

function keydownListener(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    toggleComponent();
  }
}
const isPaymentModal = computed(() => dialogStore.componentProps?.paymentData && loaders.payment);

function handleSelfClick() {
  if (isPaymentModal.value) {
    return;
  }

  if (dialogStore.componentProps?.selfClick) {
    toggleComponent();
  }
}

function onClosed() {
  if (dialogStore.componentProps?.closed) {
    dialogStore.componentProps?.closed();
  }
}

const dialogComponent = computed(() => {
  if (!dialogStore.componentName) {
    return null;
  }
  return defineAsyncComponent(() => import(`./components/${dialogStore.componentName}.vue`));
});

onMounted(() => {
  if (import.meta.client) {
    document.addEventListener('keydown', keydownListener);
    // toggleComponent(true);
  }
});

onUnmounted(() => {
  if (import.meta.client) {
    document.removeEventListener('keydown', keydownListener);
    document.body.classList.remove('overflow-hidden');
  }
});
</script>

<style lang="scss" scoped>
@use '@/assets/styles/animations.scss';

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;

  background: rgba(17, 17, 19, 0.75);

  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}

.hidden {
  opacity: 0;
  z-index: -1;
}
</style>
